import request from "../../../utils/request";

export const getRemain = '/product/giveaway/remain';

export function modifyGiveawayRemain(data: any) {
    return request.request({
        url: '/product/giveaway/remain',
        method: 'post',
        params: data
    })
}

